module.exports = __webpack_public_path__ + "img/SR3_Screen_1.14f12eb0.jpg";